// extracted by mini-css-extract-plugin
module.exports = {"actual":"a10a3f92e9--actual--JLQvc","label":"a10a3f92e9--label--aOf1l","description":"a10a3f92e9--description--vHajf","link":"a10a3f92e9--link--FJ6_x"};